import { useState } from "react";

const InstructorBioBaad = () => {
	const [showMore, setShowMore] = useState(false);

	return (
		<div className="instructor-container">
			<p className="instructor-bio">
				Hello! I’m Pradnya, and I’ll be your mentor on this creative journey. My
				path into the world of design wasn't traditional, and that is exactly
				what makes my approach different.
			</p>

			<p className="instructor-bio">
				I am a Product Designer and Graphic Designer by trade and passion, and I
				am also the Co-founder of SimplyWebDev. Interestingly, my formal
				background is actually a Diploma in AI and Machine Learning (AIML).
			</p>

			<p className="instructor-bio">
				While I spent years studying the logic of code and algorithms, my heart
				wasn't in the syntax or the terminal — it was in the visuals, the user's
				emotions, and the way a product actually feels in someone's hands from
				the very beginning.
			</p>

			{showMore && (
				<>
					<p className="instructor-bio">
						I gained my expertise through curiosity, trial and error, and a
						relentless drive to build beautiful things. I believe that great
						design isn't about the certificate on your wall — it's about the
						problem you solve and the empathy you have for the user.
					</p>

					<p className="instructor-bio">
						Because of this, I love sharing my knowledge and helping others with
						their passion in designing. This is exactly how I came up with this
						course — to help you all make your dreams come true.
					</p>

					<p className="instructor-bio">
						In this phase of the course, we are here to help you finally bridge
						the gap between “wanting to create” and “actually building.” We know
						exactly what it feels like to have a dream of becoming a UI/UX
						designer but not knowing where to click first.
					</p>

					<p className="instructor-bio">
						Whether you have a technical background or are starting from zero,
						this course strips away the jargon to empower your creative
						intuition.
					</p>

					<p className="instructor-bio">
						You’ve dreamed of designing apps and websites people love — now, I’m
						giving you the tools, Figma secrets, and design thinking to make
						that a reality.
					</p>

					<p className="instructor-bio">
						My courses are beginner-friendly and built to take your skills to
						the next level. Join me on this beautiful journey of design and see
						for yourself.
					</p>
				</>
			)}

			<button
				className="show-more-btn"
				onClick={() => setShowMore((prev) => !prev)}
			>
				{showMore ? "Show less" : "Show more"}
			</button>
		</div>
	);
};
export default InstructorBioBaad;
